module.exports = __webpack_public_path__ + "static/media/icon-decisionmakingstyle.1f8b7d43.svg";